import { useQuery } from '@tanstack/react-query';

import { profilesApi } from '@/api';

export const useGetMyProfile = () => {
    return useQuery({
        queryKey: ['my-profile'],
        queryFn: () => profilesApi.getMyProfile(),
    });
};
